import { Card, Typography } from "@mui/material";
import { useMemo } from "react";

import CustomTable from "../CustomTable";

type ComponentProps = {
  isTask: boolean;
  data: any;
};

const SupportResult = ({ isTask, data }: ComponentProps) => {
  const headersSupport = [
    {
      title: "Completed",
      className: "text-sm font-semibold text-nowrap text-success text-center",
    },
    {
      title: "Closed",
      className: "text-sm font-semibold text-nowrap text-error text-center",
    },
  ];

  const columnsSupport = [
    {
      key: "complete_count",
      value: (data: any) => data?.complete_count,
      className: "text-center text-success font-bold text-3xl",
    },
    {
      key: "close_count",
      value: (data: any) => data?.close_count,
      className: "text-center text-error-dark font-bold text-3xl",
    },
  ];

  const dataSupport = useMemo(() => {
    const items = [
      {
        complete_count: isTask
          ? data?.support_result_today?.complete_count
          : data?.support_result_today?.complete_count_qty || 0,
        close_count: isTask
          ? data?.support_result_today?.close_count || 0
          : data?.support_result_today?.close_count_qty || 0,
      },
    ];
    return items;
  }, [isTask, data?.support_result_today]);

  return (
    <Card className="p-4">
      <Typography variant="body1" className="font-semibold mb-2">
        Support Result
      </Typography>
      <CustomTable
        loading={false}
        headers={headersSupport}
        rows={dataSupport}
        columns={columnsSupport}
        disabledShadow={true}
        noEntriesRow={true}
      />
    </Card>
  );
};

export default SupportResult;
